import { Box, Grid, Typography, useTheme } from "@material-ui/core";
import { codeBgColor, codeTextColor } from "./codeMirrorEditor";

import Bold from "~/components/typography/bold";
import DoneOutlinedIcon from "@material-ui/icons/DoneOutlined";
import GenericSvgIconWrapper from "~/icons/genericSvgIconWrapper";
import React from "react";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import styled from "styled-components";

const Wrapper = styled(Box)<{ $status: "success" | "error" }>`
  padding: 0.75rem;
  border-width: 1px;
  border-style: solid;
  ${({ theme, $status }) => `
    border-color: ${theme.palette[$status].main};
    border-radius: ${theme.shape.borderRadius}px;
    background-color: ${theme.palette.background.paper};
    color: ${theme.palette.text.primary};
  `}
`;

const ErrorMessage = styled(Box)`
  padding: 0.5rem;
  border-radius: 0.625rem;
  background: ${codeBgColor};
  color: ${codeTextColor};
`;

interface ValidationResultProps {
  status: "success" | "error";
  title: string;
  errorMessage: string | null;
}

const ValidationResult: React.FC<ValidationResultProps> = ({
  status,
  title,
  errorMessage,
}) => {
  const theme = useTheme();
  // Additional guard
  const $status = status === "success" ? "success" : "error";
  return (
    <Wrapper $status={$status}>
      <Grid container wrap="nowrap" spacing={1}>
        <Grid item>
          <GenericSvgIconWrapper $color={theme.palette[$status].main}>
            {$status === "success" ? (
              <DoneOutlinedIcon />
            ) : (
              <ReportProblemOutlinedIcon />
            )}
          </GenericSvgIconWrapper>
        </Grid>
        <Grid item>
          <Bold variant="h5" $color={theme.palette[$status].main}>
            {title}
          </Bold>
        </Grid>
      </Grid>
      {errorMessage && (
        <Box mt={2}>
          <ErrorMessage>
            <Typography variant="body1" color="inherit">
              {errorMessage}
            </Typography>
          </ErrorMessage>
        </Box>
      )}
    </Wrapper>
  );
};

export default ValidationResult;
